import { HttpClient } from '../interceptor';

export class UserManagementApi{
    // 获取用户列表
    static getUserList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/AuthController/queryUser', param).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }
    // 新增用户
    static insertUser = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/AuthController/addUser', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
    // 删除用户
    static deleteUser = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/AuthController/deleteUser', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
}





